export default "__VITE_ASSET__CFEZypEM__"